import axiosInstance from '../../apiServices/axios';
import { DOC_PROJECT, NDA_DOC } from '../../apiServices/api_routes';

export const projectFilesUrl = projectId => `${DOC_PROJECT}${projectId}/files/`;
export const setupSuggestUrl = (projectId, action) => `${DOC_PROJECT}${projectId}/setup/${action}/`;

export async function uploadProjectFile(projectId, file) {
    const body = new FormData();
    body.append('document', file);
    body.append('document_name', file.name);
    const response = await axiosInstance.post(projectFilesUrl(projectId), body);
    return response.data;
}

export async function getProjectFilesStatus(projectId) {
    const response = await axiosInstance.get(setupSuggestUrl(projectId, 'files-status'));
    return response.data;
}

export async function retryProjectFiles(projectId, fileIds = []) {
    const response = await axiosInstance.post(setupSuggestUrl(projectId, 'retry-files'), {
        file_ids: fileIds,
    });
    return response.data;
}

export function formatFileSize(bytes) {
    const size = Number(bytes);
    if (!Number.isFinite(size) || size < 0) return '';
    if (size < 1024) return `${Math.round(size)} B`;
    const kb = size / 1024;
    if (kb < 1024) return `${Math.round(kb)} KB`;
    return `${(kb / 1024).toFixed(1).replace(/\.0$/, '')} MB`;
}

export async function suggestOrganisation(projectId, sources) {
    const body = {};
    if (sources) {
        body.coresignal_enrichment = sources.coresignal_enrichment || sources.enrichment || {};
        body.public_ai_enrichment = sources.public_ai_enrichment || {};
    }
    const response = await axiosInstance.post(setupSuggestUrl(projectId, 'suggest-organisation'), body);
    return response.data;
}

export async function suggestEngagement(projectId) {
    const response = await axiosInstance.post(setupSuggestUrl(projectId, 'suggest-engagement'));
    return response.data;
}

export async function suggestWorkstreams(projectId) {
    const response = await axiosInstance.post(setupSuggestUrl(projectId, 'suggest-workstreams'));
    return response.data;
}

export async function suggestFolders(projectId, workstreams) {
    const response = await axiosInstance.post(setupSuggestUrl(projectId, 'suggest-folders'), {
        workstreams: workstreams || [],
    });
    return response.data;
}

export async function suggestIrl(projectId, workstreams) {
    const response = await axiosInstance.post(setupSuggestUrl(projectId, 'suggest-irl'), {
        workstreams: workstreams || [],
    });
    return response.data;
}

export function provenanceSourceLabel(source) {
    if (!source) return '';
    const value = String(source).toLowerCase();
    if (value === 'document') return 'Document';
    if (value === 'coresignal') return 'Coresignal';
    if (value === 'custom') return 'Custom';
    if (value === 'ai' || value === 'ai_classification' || value === 'lens') return 'Lens';
    return source;
}

export function fieldMetaFromSources(fieldMeta = {}) {
    const next = {};
    Object.entries(fieldMeta).forEach(([key, meta]) => {
        if (!meta) return;
        next[key] = {
            ...meta,
            source: provenanceSourceLabel(meta.source),
        };
    });
    return next;
}

export const projectNdasUrl = projectId => `${NDA_DOC}${projectId}/`;

export async function listProjectNdas(projectId) {
    const response = await axiosInstance.get(projectNdasUrl(projectId));
    return response.data;
}

export async function uploadProjectNda(projectId, file, { name, expiry } = {}) {
    const body = new FormData();
    body.append('document', file);
    if (name) body.append('name', name);
    if (expiry) body.append('expiry', expiry);
    const response = await axiosInstance.post(projectNdasUrl(projectId), body);
    return response.data;
}
